import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Settings } from "../app.settings";
import { map } from 'rxjs/operators';

@Injectable()
export class DataProvider {
  constructor(private http: HttpClient, private settings: Settings) { }

  public getData(dataUrl){
    return this.http.get(this.settings.apiUrl + dataUrl).pipe(map((response: Response) => response as any));
  }

  public postData(dataUrl, body) {
    return this.http.post(this.settings.apiUrl + dataUrl, body).pipe(map((response: Response) => response as any));
  }
}
